<!-- Locked (premium) version -->
@if (locked$ | async) {
  <span style="display: inline-flex; align-items: center">
    <img
      style="margin-right: 5px"
      width="24"
      height="24"
      src="/assets/img/icons/cyborg-premium-icon.png"
    />
    <hyperkit-link
      (click)="openPremiumDialog()"
      variant="h5"
      color="primary"
      [text]="huntPackage.title"
    >
    </hyperkit-link>
  </span>
} @else {
  <hyperkit-link
    [routerLink]="['/research/hunt-package', huntPackage.UUID]"
    variant="h5"
    color="primary"
    [text]="huntPackage.title"
  >
  </hyperkit-link>
}

<!-- Unlocked version -->
